<template>
  <div class="headerRoot">
    <div
      class=" py-1"
      style=" background: #1E1B29;"
    >
      <v-layout class="mainPanel caption">
        <div class="useTypeWrap">
          <a
            :class="{active: type === 'individual'}"
            class="mr-4"
            @click="type = 'individual'"
          >個人版</a>
          <a
            :class="{active: type === 'businesse'}"
            class="mr-2"
            @click="type = 'businesse'"
          >商戶版</a>
        </div>
        <v-spacer />
      </v-layout>
    </div>
    <div
      :class="$route.name"
      class="mainPanel"
    >
      <v-layout
        align-center
        class="header ma-0"
      >
        <div class="logoWrap">
          <a
            v-if="installedCrx"
            href="/"
            style="text-decoration: none;"
          >
            <img
              :src="$store.getters['theme/pcLogo1']"
              style="vertical-align: middle;"
            >
            <img
              :src="$store.getters['theme/pcLogo3']"
              style="vertical-align: middle;"
            >
          </a>
          <template v-else>
            <a
              href="/"
            >
              <img
                :src="$store.getters['theme/pcLogo1']"
                style="vertical-align: middle;"
              >
            </a>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <a
                  href="https://chrome.google.com/webstore/detail/%E5%B7%A7%E5%B7%A7%E9%83%8E%E5%8C%85%E8%A3%B9%E7%AE%A1%E5%AE%B6/lacejchmbljdoaimkbmcflcechgndbim"
                  target="_blank"
                >
                  <img
                    :src="$store.getters['theme/pcLogo2']"
                    style="vertical-align: middle;height: 100px;margin: 0 3px;"
                    v-on="on"
                  >
                </a>
              </template>
              <div
                class="orange--text"
                style="font-size: 18px;"
              >
                恭喜你找到了！你太聰明了！<br>
                點擊前往安裝【巧巧郎的鑰匙】就可以解鎖完成喲！
              </div>
            </v-tooltip>
            <img
              :src="$store.getters['theme/pcLogo3']"
              style="vertical-align: middle;"
            >
          </template>
        </div>
        <v-spacer />

        <div
          v-if="false"
          class="navWrap"
        >
          <router-link :to="{name:'Login'}">
            首頁
          </router-link>
          <!-- <a>運費</a> -->
          <router-link :to="{name:'HomeCalendar'}">
            行事曆
          </router-link>
          <router-link :to="{name:'HomeAddress'}">
            倉庫
          </router-link>

          <span>｜</span>
          <!-- <a>丟失理賠</a> -->
          <router-link :to="{name:'SuspendPost'}">
            停權公告
          </router-link>
        </div>

        <!-- <div class="mt-2">
          ❲<a
            href="https://www.facebook.com/groups/820402451989696"
            target="_blank"
            class="subtitle-1 "
          >巧巧郎社團</a>❳ &nbsp;
        </div> -->
        <!-- <iframe
            src="//www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fkkrencomtw&amp;width=168&amp;layout=button_count&amp;action=like&amp;show_faces=true&amp;share=true&amp;height=51&amp;appId=264229304591551"
            scrolling="no"
            frameborder="0"
            style="border:none; overflow:hidden; width:125px; vertical-align: bottom; height:20px; line-height:20px;"
            allowtransparency="true"/> -->
        <!-- <div v-if="$route.name === 'About'">
          <img
            src="../images/about-logo.png"
            style="vertical-align: middle;"
          >
        </div> -->
      </v-layout>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    useType: String,
  },
  data () {
    return {
      innerHeight: window.innerHeight,
      type: this.useType || 'individual', // individual or businesse
    }
  },
  computed: {
    installedCrx () {
      return this.$store.state.installedCrx
    },
  },
  watch: {
    type (v) {
      this.$emit('update:useType', v)
    }
  }
}
</script>
<style lang="postcss" scoped>
.header {
  height: 90px;
  margin-bottom: 20px;
}
.About .header {
}
.useTypeWrap {
  a {
    color: #fff;
    &.active {
      color: #E9B819;
    }
  }
}
.logoWrap {
  margin-top: -10px;
  img {
    height: 80px;
  }
}
.headerRoot {
  position: relative;
  z-index: 2;
  background: rgba(255,255,255,0.8);
}
.navWrap {
  > * {
    margin: 0 10px;
    color: #fff;
    font-size: 18px;
    color: #1E1B29;
    text-decoration: none;
  }
  > a {
    &:hover,&.active {
      color: #E9B819;
    }
  }
}
</style>
